import { NavLink, Link } from "react-router-dom";
import { Waves } from "lucide-react";

const links = [
    { to: "/", label: "Home", id: "nav-home", end: true },
    { to: "/games", label: "Games", id: "nav-games" },
    { to: "/team", label: "Team", id: "nav-team" },
    { to: "/about", label: "About Us", id: "nav-about" },
];

export const Navbar = () => {
    return (
        <header
            data-testid="site-navbar"
            className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#000000]/70 border-b border-white/10"
        >
            <div className="max-w-7xl mx-auto flex items-center justify-between px-6 md:px-10 h-16">
                <Link
                    to="/"
                    data-testid="nav-logo"
                    className="flex items-center gap-2.5 group"
                >
                    <span className="relative inline-flex items-center justify-center w-9 h-9 rounded-lg bg-gradient-to-br from-blue-500/20 to-cyan-400/10 border border-white/10">
                        <Waves className="w-5 h-5 text-teal-400" strokeWidth={2.25} />
                    </span>
                    <span className="font-display text-lg font-bold tracking-tight text-white">
                        Deep <span className="text-teal-400">Current</span>
                    </span>
                </Link>

                <nav className="flex items-center gap-1 sm:gap-2">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.end}
                            data-testid={l.id}
                            className={({ isActive }) =>
                                `nav-link px-3 sm:px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                                    isActive
                                        ? "text-white bg-white/10 border border-white/15"
                                        : "text-slate-300 hover:text-white hover:bg-white/5"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>
            </div>
        </header>
    );
};

export default Navbar;
